module.exports = __webpack_public_path__ + "img/knowledge-element.9fff7a40.png";